import React, { useContext, useEffect, useRef, useState } from 'react';
import { PngImages, SvgImages } from "../../Utils/LocalImages"
import { Link, useNavigate } from 'react-router-dom';
import RoutesPath from '../../Utils/RoutesPath';
import Image from '../../Components/Reusable/Image';
import { useSidebar } from '../../Context/toggleContext';
import { AuthContext } from '../../Context/authContext';
import SubmitButtonTwo from '../../Components/Reusable/Buttontwo';
import SessionManager from '../../Utils/Session';


const CoordinatorNavbar = () => {
  const navigate = useNavigate();
  const { coordinator } = useContext(AuthContext)
  const [showLoginDropDown, setShowLoginDropDown] = useState(false);

  
    const { toggleSidebar } = useSidebar()

    const handleclosemodal = () => {
      setShowLoginDropDown(false);
    };

    const logindropdownRef = useRef(null);
  const handleButtonClick = () => navigate(RoutesPath.login);

  const handleClickOutside = (event) => {
    if (logindropdownRef.current && !logindropdownRef.current.contains(event.target)) {
      setShowLoginDropDown(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  const toggleLoginDropdown = (event) => {
    event.stopPropagation();
    setShowLoginDropDown(prev => !prev);
  };

  const handleLogout = () => {
    setShowLoginDropDown(false);
    SessionManager.shared.logoutCoordinator();  
  };


  return (
    <nav className=" cotopnavbar d-flex align-items-center justify-content-between">
      <button
        className="navbar-toggler-co"
        onClick={toggleSidebar}
      >
        ☰
      </button>
      <h4 className="blue mb-0 sub-large-text-one fw-600 Responsivetextwel">{`Welcome, ${coordinator?.name?.trim()}!`}</h4>
      <div className="right-admin-profile d-flex align-items-center" style={{ paddingRight: '30px' }}>
        <div className="d-flex align-items-center gap-4">
          <div>
            <a href={RoutesPath.dashboardcoordinator} className="">
              <Image src={SvgImages.coordinatornotification} alt="Notification" />
            </a>
          </div>
          
          <div className='Button-navbar ms-auto position-relative' >
          <Image src={SvgImages.coordinatorpowerbtn} alt="Notification" className="cursor-pointer" onClick={toggleLoginDropdown} />

          <div 
              ref={logindropdownRef}
              className={`dropdown-menu modalregistered selectSection ${showLoginDropDown ? "show" : ""}`} 
              aria-labelledby="dropdownMenuLink" 
              data-popper-placement="bottom-end"
            >             
             <div className='d-flex gap-3 align-items-center'>
                <div className='d-flex flex-column gap-3'>
                  <h2 className='small-medium-text black text-center mb-0 fw-600'>Are you Sure you want to logout?</h2>
                  <div className='d-flex gap-2 justify-content-center'>
                    <Link to={RoutesPath.home}>
                      <SubmitButtonTwo title={"Yes"} className="yesbutton cursor-pointer" onclick={handleLogout} />
                    </Link>
                    <Link to={RoutesPath.dashboardcoordinator}>
                      <SubmitButtonTwo title={"No"} className="nobutton cursor-pointer" onclick={handleclosemodal} />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="dropdown position-relative">
            <a className="fs-16 fw-500 black dropdown-toggle d-flex align-items-center" onClick={() => setShowProfileDropDown(true)} role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="true">
              <Image className="profile_img" style={{ objectFit: "cover" }} src={user?.profile_pic && user.profile_pic?.trim() !== "" ? ApiConstants.FILE_FETCH_URL + user.profile_pic : SvgImages.user_profile} onError={({ currentTarget }) => {
                currentTarget.onerror = null; // prevents looping
                currentTarget.src = SvgImages.user_profile;
              }} />
            </a>
            <ul className={`dropdown-menu profiles_dropdown selectSection ${showProfileDropDown ? "show" : ""}`} aria-labelledby="dropdownMenuLink" data-popper-placement="bottom-end">
              <Link to={RoutesPath.viewProfile}>
                <div className="mb-2">
                  <li className="profile_dropdown fs-16 fw-500 black border_bottom">
                    <Image className="profile_img" style={{ objectFit: "cover" }} src={user?.profile_pic && user.profile_pic?.trim() !== "" ? ApiConstants.FILE_FETCH_URL + user.profile_pic : SvgImages.user_profile} onError={({ currentTarget }) => {
                      currentTarget.onerror = null; // prevents looping
                      currentTarget.src = SvgImages.user_profile;
                    }} />
                    <div className="profile_details">
                      <h2>{user?.name?.trim()}</h2>
                      <h3>Admin</h3>
                    </div>
                  </li>
                </div>
              </Link>
              <button className="view_profile border-bottom" data-number="8">
                <Link to={RoutesPath.viewProfile}>
                  <li className="profile_card">
                    <Image src={SvgImages.profile} alt="Profile" />
                    View Profile
                  </li>
                </Link>

                <Link to={RoutesPath.changePasswordProfile}>
                  <li className="profile_card">
                    <Image src={SvgImages.lock} style={ImageFilters.black} alt="Profile" />
                    Change Password
                  </li>
                </Link>
              </button>
              <li className="profile_card primary mt-2 mb-0" data-bs-target="#logoutmodal" data-bs-toggle="modal" onClick={() => setShowConfirmationModal(true)}>
                <img src={SvgImages.profile_logout} alt="Logout" />Logout
              </li>
            </ul>
          </div> */}
        </div>
      </div>
    </nav>
  );
};

export default CoordinatorNavbar;
